import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import CloseButton from './CloseButton';

import vw from 'styles/utils';

function ImageModal(props) {
  const { show, srcUrl, url, onClickCloseButton } = props;

  return (
    <Root show={show}>
      <Container>
        <img src={srcUrl} alt="modal" />
        <ViewButton href={url} target="_blank">觀看簡報連結</ViewButton>
        <CloseButton onClick={onClickCloseButton} />
      </Container>
    </Root>
  )
}

ImageModal.propTypes = {
  show: PropTypes.bool,
  srcUrl: PropTypes.any,
  onClickCloseButton: PropTypes.func
}

const Root = styled.div`
  width: 100%;
  height: 100vh;
  display: ${props => props.show ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99;
`;

const Container = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* width: 1062px;
  height: 857px; */
  position: relative;
  max-width: 95%;
  max-height: 95vh;
  
  ${vw('width', 260, 650, 1062)}
  ${vw('height', 320, 600, 857)}
  /* ${vw('padding-left', 60, 30, 109)}
  ${vw('padding-right', 60, 30, 109)}
  ${vw('padding-top', 60, 30, 89)}
  ${vw('padding-bottom', 60, 30, 89)} */

  > img {
    width: auto;
    height: auto;
    max-width: 80%;
    max-height: 80vh;
    border: 1px solid #DADADA;

    ${vw('margin-bottom', 45)}
    ${vw('padding-top', 10, 20, 30)}
  }
`;

const ViewButton = styled.a`
  /* width: 116px;
  height: 26px; */
  background: #26304D;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  line-height: 180%;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.25s ease-out;

  ${vw('width', 116)}
  ${vw('heighte', 26)}
  ${vw('font-size', 12)}
  ${vw('margin-bottom', 10, 20, 30)}

  &:hover {
    color: #3398DC;
  }
`;

export default ImageModal
